export const AUTH_MARKER_COOKIE = 'admin_authenticated';

const MAX_AGE_SECONDS = 60 * 120;

function cookieSecuritySuffix(): string {
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    return '; Secure';
  }
  return '';
}

export function hasAuthMarkerCookie(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  return document.cookie.split('; ').some((row) => row.startsWith(`${AUTH_MARKER_COOKIE}=1`));
}

export function isAuthenticated(): boolean {
  return hasAuthMarkerCookie();
}

export function setAuthMarkerCookie(): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie = `${AUTH_MARKER_COOKIE}=1; Path=/; Max-Age=${MAX_AGE_SECONDS}; SameSite=Lax${cookieSecuritySuffix()}`;
}

export function clearAuthMarkerCookie(): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie = `${AUTH_MARKER_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax${cookieSecuritySuffix()}`;
}

export function redirectToLogin(): void {
  if (typeof window === 'undefined') {
    return;
  }
  const path = window.location.pathname;
  if (path === '/login' || path.startsWith('/auth/callback')) {
    return;
  }
  window.location.href = '/login';
}
